/*
 * @Descripttion:
 * @version    :
 * @Author     : wuyujiang
 * @Date       : 2024-10-23 08:44
 * @LastAuthor : wuyujiang
 * @LastTime   : 2024-11-20 09:37
 * @Version    : v1.00
 * @desc       :
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/css/common.css";
Vue.config.productionTip = false;
import axios from "axios";
import VueAxios from "vue-axios";
/* eslint-disable no-new */
Vue.use(VueAxios, axios);
// import { getRequestNoToken } from "./commonJs/request";
let getRequestNoToken = function(url, params) {
  return axios({
    method: "get",
    url: `${url}`,
    params: params,
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    contentType: "application/json; charset=utf-8"
  });
};
Vue.prototype.gets2 = getRequestNoToken;

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js